export const dateEntities = {
  from: 'from',
  to: 'to',
};

export const paramKeys = {
  [dateEntities.from]: 'newFromDate',
  [dateEntities.to]: 'newToDate',
};

export const methodNames = {
  check: 'check',
  add: 'add',
  delete: 'delete',
};

export const endPoints = {
  [dateEntities.from]: {
    [methodNames.check]: 'check_from_date',
    [methodNames.add]: 'change_from_date_and_add_dates_and_intervals',
    [methodNames.delete]: 'change_from_date_delete_dates_and_intervals',
  },
  [dateEntities.to]: {
    [methodNames.check]: 'check_to_date',
    [methodNames.add]: 'change_to_date_and_add_dates_and_intervals',
    [methodNames.delete]: 'change_to_date_delete_dates_and_intervals',
  },
};
